module.exports = __webpack_public_path__ + "img/7.8fb1dd21.jpg";